module.exports = __webpack_public_path__ + "static/media/addr.6d02f066.svg";